import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CxFormsModule } from '@forms';
import { DxPopupModule } from 'devextreme-angular/ui/popup';
import { FormsModule } from '@angular/forms';
import { UiMessagesModule } from '@ui-messages';
import { UiFormatModule } from '@ui-format';
import { ConverterModule } from '@converter';


import { LicenseListComponent } from './license-list.component';
import { LicenseService } from './license.service';
import { LicenseDetailsComponent } from './license-details.component';
import { RouterModule } from '@angular/router';
import { PrivilegesModule } from '@privileges';
import { LoaderModule } from '@loader';


@NgModule({
    imports: [
        CommonModule,
        CxFormsModule,
        DxPopupModule,
        FormsModule,
        UiMessagesModule,
        UiFormatModule,
        RouterModule,
        ConverterModule,
        PrivilegesModule,
        LoaderModule
    ],
    declarations: [
       LicenseListComponent,
       LicenseDetailsComponent
    ],
    exports: [
        LicenseListComponent,
        LicenseDetailsComponent
    ],
    providers: [
        LicenseService
    ]
})
export class LicenseModule {}

export {
    LicenseListComponent,
    LicenseService,
    LicenseDetailsComponent
}
